import { commonQuestionnaires } from "./common";
import { speechTherapistQuestionnaires } from "./speechTherapist";
import { psychologistQuestionnaires } from "./psychologist";
import { psychotherapistQuestionnaires } from "./psychotherapist";
import { occupationalTherapistQuestionnaires } from "./occupationalTherapist";

export const ALL_SYSTEM_QUESTIONNAIRES = [
  ...commonQuestionnaires,
  ...speechTherapistQuestionnaires,
  ...psychologistQuestionnaires,
  ...psychotherapistQuestionnaires,
  ...occupationalTherapistQuestionnaires,
].map((item) => ({ ...item, isSystem: true }));

export const getSystemQuestionnaires = (clinicType) =>
  ALL_SYSTEM_QUESTIONNAIRES.filter((q) => q.clinicTypes.includes(clinicType));
